import React, { useEffect, useRef } from 'react';
import { useJwtAuth } from './useJwtLogin';

type Props = {
  authorizationCode: string;
};

const LoginWithAuthorizationCode: React.FC<React.PropsWithChildren<Props>> = ({
  authorizationCode,
}) => {
  const { doLoginByAuthorizationCode } = useJwtAuth();
  // The authorization code is single-use (it is exchanged and the previous
  // tokens are deleted). Guard against StrictMode's double-invoke so the code
  // is exchanged exactly once.
  const hasAttemptedLogin = useRef(false);

  useEffect(() => {
    if (hasAttemptedLogin.current) {
      return;
    }
    hasAttemptedLogin.current = true;

    doLoginByAuthorizationCode(authorizationCode);
  }, [doLoginByAuthorizationCode, authorizationCode]);

  return <></>;
};

export default LoginWithAuthorizationCode;
